/**
 * Edit-mode seeder — maps the `{date, timeRanges, enabled}` payload
 * shape the backend returns back into the internal `DayStateMap`.
 * Every seeded range becomes a custom slot so it survives the
 * availability pipeline regenerating (the user already committed to
 * those exact times last time they scheduled).
 */
import type { DayStateMap } from './types';
import type { SelfSlot } from '../types';

export interface InitialSlotsPayload {
  date: string;
  timeRanges: Array<{ startTime: string; endTime: string }>;
  enabled: boolean;
}

export function seedFromInitial(initial?: InitialSlotsPayload[]): DayStateMap {
  const out: DayStateMap = {};
  if (!initial) return out;

  for (const day of initial) {
    if (!day.enabled || day.timeRanges.length === 0) continue;
    const customSlots: SelfSlot[] = day.timeRanges.map((range) => ({
      id: `seed-${day.date}-${range.startTime}-${range.endTime}`,
      start: `${day.date}T${range.startTime}`,
      end: `${day.date}T${range.endTime}`,
      dateKey: day.date,
      isCustom: true,
    }));
    out[day.date] = {
      isSelected: true,
      removedIds: new Set(),
      customSlots,
    };
  }

  return out;
}
